import React from 'react'
import { Navigation } from 'types/navigation'
import { Home, NoteAdd, Handshake, Dashboard, AccountBalanceWallet, AccountBalance } from '@mui/icons-material'
import { ClientHome, ApplicationNew, ClientFinancingProfile } from 'views/Client'

export const clientPages: Navigation = [
  { kind: 'header', title: 'Client' },
  {
    segment: 'client',
    title: 'Home',
    icon: <Home />,
    component: <ClientHome />,
  },
  {
    segment: 'client/financing-profile',
    title: 'Financing Profile',
    icon: <AccountBalance />,
    component: <ClientFinancingProfile />,
  },
]
